(() => {
  const init = () => {
    const header = document.querySelector('[data-arc-header]');
    const widget = document.querySelector('[data-arc-currency-widget]');
    if (!header || !widget || widget.dataset.arcReady) return;
    widget.dataset.arcReady = 'true';
    const mobile = matchMedia('(max-width: 749px)');
    const place = () => {
      const slot = header.querySelector(mobile.matches ? '[data-arc-currency-mobile]' : '[data-arc-currency-desktop]');
      if (slot && widget.parentElement !== slot) slot.append(widget);
    };
    const codeFromPage = () => document.querySelector('[bucks-currency]')?.getAttribute('bucks-currency');
    const sync = currency => {
      const code = typeof currency === 'string' && /^[A-Z]{3}$/.test(currency) ? currency : codeFromPage();
      if (code && /^[A-Z]{3}$/.test(code)) header.querySelectorAll('[data-arc-currency-code]').forEach(node => { node.textContent = code; });
    };
    const selected = event => sync(event.detail);
    place(); sync();
    mobile.addEventListener('change', place);
    document.addEventListener('BUCKS_SELECTED_CURRENCY', selected);
    let checks = 0;
    const timer = setInterval(() => {
      sync();
      const ready = widget.querySelector('.buckscc-currency-wrapper');
      if (ready || ++checks >= 30) {
        clearInterval(timer);
        widget.querySelector('[data-arc-currency-help]').hidden = Boolean(ready);
      }
    }, 1000);
    const observer = new MutationObserver(() => {
      if (widget.querySelector('.buckscc-currency-wrapper')) widget.querySelector('[data-arc-currency-help]').hidden = true;
    });
    observer.observe(widget, {childList:true,subtree:true});
    header.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      clearInterval(timer); observer.disconnect(); mobile.removeEventListener('change', place);
      document.removeEventListener('BUCKS_SELECTED_CURRENCY', selected);
    }, {once:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
